import { cva } from 'class-variance-authority';

/**
 * Styles for PasswordRequirementIndicator component
 * Uses design tokens for colors
 */
export const passwordRequirementIndicatorStyles = cva(
  [
    'flex',
    'gap-2',
    'items-center',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

export const passwordRequirementIndicatorTextStyles = cva(
  [
    'font-["Poppins"]',
    'font-normal',
    'text-sm', // 14px
    'leading-5',
    'tracking-[0.25px]',
  ],
  {
    variants: {
      isMet: {
        true: [
          'text-tertiary', // Success/green color from design tokens
        ],
        false: [
          'text-outline', // Outline color from design tokens
        ],
      },
    },
    defaultVariants: {
      isMet: false,
    },
  }
);

export const passwordRequirementIndicatorIconStyles = cva(
  [
    'shrink-0',
    'size-6',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
